import { Select, Space } from "antd"
import React, { useEffect, useState } from "react"
import { useCollection } from "../../hooks/useCollection"
import UpdateClientModal from "./UpdateClientModal"

export default function Client({ value, setValue, user, nullKeys, setNullKeys }) {
  //clients data form db
  const [allClients, setAllClients] = useState()
  //change state of showing opened before in update modal
  const [openedBefore, setOpenedBefore] = useState(true)

  //fetches client data
  const { data: clients, loading: clientsLoading } = useCollection(
    "clients",
    ["user", "==", user.uid],
    ["approved", "==", true]
  )

  //sets the data of the clients
  useEffect(() => {
    setAllClients(clients)
  }, [clients])

  //updates state
  const handleChange = (value, option) => {
    setValue(option)
    console.log(option)
    setOpenedBefore(false)
  }

  // update selected value when client data changes
  useEffect(() => {
    if (value && allClients) {
      const selectedClient = allClients.find((client) => client.client === value.client)
      setValue(selectedClient)
    }
  }, [allClients, value, setValue])

  //select style
  const style = { width: "100%" }

  const select = (
    <>
      <Select
        showSearch
        loading={clientsLoading}
        fieldNames={{ value: "client", label: "client" }}
        onChange={handleChange}
        value={value && value.client}
        style={style}
        placeholder="Select client"
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.client ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={allClients}
      />
    </>
  )

  return (
    <>
      {nullKeys ? (
        <>
          <Space.Compact block>
            {select}
            <UpdateClientModal
              opened={openedBefore}
              data={value}
              setOpened={setOpenedBefore}
              setNullKeys={setNullKeys}
            />
          </Space.Compact>
        </>
      ) : (
        <>
          {select}
          <UpdateClientModal
            opened={openedBefore}
            data={value}
            setOpened={setOpenedBefore}
            setNullKeys={setNullKeys}
          />
        </>
      )}
    </>
  )
}
